(($) => {
    $('.dropdown-toggle').dropdown();
})($);